/* eslint-disable react-refresh/only-export-components */
/* eslint-disable filename-rules/match */

import { t } from "i18n/i18n";
import { GearSettingsIcon, PersonSingleIcon, PersonSingleStarIcon, StarIcon } from "mds/icons";
import { HomeRoleType } from "utils/urls";

export const PARTICIPANT_ROLES = ["student", "instructor", "section_assistant"] as const;
export const ASSESSING_ROLES = ["instructor", "section_assistant"] as const;

// Use Permissions for these things
export const isStaff = (role: HomeRoleType) => role !== "student";
export const isAssessor = (role: HomeRoleType) =>
  ASSESSING_ROLES.includes(role as (typeof ASSESSING_ROLES)[0]);
export const isParticipant = (role: HomeRoleType) =>
  PARTICIPANT_ROLES.includes(role as (typeof PARTICIPANT_ROLES)[0]);

export const roleLabel: Record<HomeRoleType, string> = {
  student: t("home.role.student"),
  instructor: t("home.role.instructor"),
  admin: t("home.role.admin"),
  section_assistant: t("home.role.section_assistant"),
};

export const roleIcon: Record<HomeRoleType, React.ReactNode> = {
  student: <PersonSingleIcon />,
  instructor: <StarIcon />,
  section_assistant: <PersonSingleStarIcon />,
  admin: <GearSettingsIcon />,
};
